import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { BeltType, CategoryType } from '../model/model'
import { fetchConfig } from './configSlice'
import { RootState } from './store'

const sliceName = 'belt'

type FetchBeltsResponseType = {
  errors: Array<string>
  result: boolean
  category: Array<BeltType>
}

type SliceStateType = {
  fetching: boolean
  list: Array<BeltType>
  categories: Record<string, Array<CategoryType>>
  idMap: Record<string, string>
  nameMap: Record<string, string>
}

const initialState: SliceStateType = {
  fetching: false,
  list: [],
  categories: {},
  idMap: {},
  nameMap: {}
}

export const fetchBelts = createAsyncThunk<FetchBeltsResponseType, undefined>(
  `${sliceName}/fetch`,
  async (_args, thunkAPI) => {
    console.log('%c%s', 'color: #917399', 'fetch belts')
    const state = (thunkAPI.getState() as RootState).config

    try {
      const response = await fetch(`${state.setting.root}belt`, {
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': state.setting.nonce
        }
      })
        .then((res) => res.json())
        .then((json) => {
          return json as FetchBeltsResponseType
        })

      return response
    } catch (e) {
      return thunkAPI.rejectWithValue({})
    }
  }
)

type BeltCategoriesResponse = {
  category: Array<CategoryType>
  errors: Array<string>
  result: boolean
}

type BeltCategoriesRequest = {
  belt_id: number
}

export const fetchBeltCategories = createAsyncThunk<BeltCategoriesResponse, BeltCategoriesRequest>(
  `${sliceName}/fetchBeltCategories`,
  async (args, thunkAPI) => {
    const state = (thunkAPI.getState() as RootState).config

    try {
      const response = await fetch(`${state.setting.root}belt/${args.belt_id}/category`, {
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': state.setting.nonce
        }
      })
        .then((res) => res.json())
        .then((json) => {
          return json as BeltCategoriesResponse
        })

      return response
    } catch (e) {
      return thunkAPI.rejectWithValue({})
    }
  }
)

export const beltSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchBelts.pending, (state) => {
      state.fetching = true
    })

    builder.addCase(fetchBelts.fulfilled, (state, action) => {
      state.fetching = false
      state.list = action.payload.category

      state.idMap = action.payload.category.reduce((result, obj) => {
        result[obj.id] = obj.title.replace('/', '_').toLowerCase()

        return result
      }, {})

      state.nameMap = action.payload.category.reduce((result, obj) => {
        const title = obj.title.replace('/', '_').toLowerCase()
        result[title] = obj.id

        return result
      }, {})
    })

    builder.addCase(fetchConfig.fulfilled, (state, action) => {
      state.list = action.payload.belts

      state.idMap = action.payload.belts.reduce((result, obj) => {
        result[obj.id] = obj.title.replace('/', '_').toLowerCase()

        return result
      }, {})

      state.nameMap = action.payload.belts.reduce((result, obj) => {
        const title = obj.title.replace('/', '_').toLowerCase()
        result[title] = obj.id

        return result
      }, {})
    })

    builder.addCase(fetchBeltCategories.fulfilled, (state, action) => {
      state.categories[action.meta.arg.belt_id] = action.payload.category
    })
  }
})
